/**
 * Options used in the color scale
 */
export const COLOR_SCALE_PRIMARY_COLORS = 'PRIMARY_COLORS';
export const COLOR_SCALE_CHARTS_COLORS = 'CHARTS_COLORS';
export const COLOR_SCALE_CHARTS_DIGITAL_CHANNELS_COLORS =
  'CHARTS_DIGITAL_CHANNELS_COLORS';

export const COLOR_SCALE_ACCENTS_COLORS = 'ACCENTS_COLORS';
export const COLOR_SCALE_LOGO_COLORS = 'LOGO_COLORS';

export const COLOR_SCALE_PRIMARY = 'PRIMARY';
export const COLOR_SCALE_SECONDARY = 'SECONDARY';
export const COLOR_SCALE_ACCENT_1 = 'ACCENT_1';
export const COLOR_SCALE_ACCENT_2 = 'ACCENT_2';
